import * as types from './actionTypes'
import { apiUrl, emailJsUserId, emailJsTemplateId, emailJsServiceId } from '../../utils/config'
import { send } from 'emailjs-com'

/*
 * Api thunks
 */
const api = {
	getHeaders: () => ({ 'Content-Type': 'application/json',
	'Access-Control-Allow-Credentials': true }),
	_fetch: (uri, { method, body, needToken, token, isFullLink }) => {
		const url = isFullLink ? uri : `${apiUrl}${uri}`
		return fetch(url, {
			method: method,
			headers: isFullLink ? {} : api.getHeaders(),
			body: JSON.stringify(body)
		})
	},
	get: (uri, params) => api._fetch(uri, { ...params, method: 'GET' }),
	put: (uri, params) => api._fetch(uri, { ...params, method: 'PUT' }),
	post: (uri, params) => api._fetch(uri, { ...params, method: 'POST' })
}

/**
 * Send email through contact form
 */
export function sendEmail (data = {}) {
	return dispatch => {
		dispatch(sendingEmail())
		return send(emailJsServiceId, emailJsTemplateId, data, emailJsUserId).then(dispatch(sentEmail()))
	}
}

export function sendingEmail () {
	return {
		type: types.SEND_EMAIL
	}
}

export function sentEmail () {
	return {
		type: types.SENT_EMAIL
	}
}

export function setErrorMsg (msg) {
	return {
		type: types.SET_ERROR_MESSAGE,
		messages: {
			error: msg
		}
	}
}

export function setSuccessMsg (msg) {
	return {
		type: types.SET_SUCCESS_MESSAGE,
		messages: {
			success: msg
		}
	}
}

export function resetMsgs () {
	return {
		type: types.SET_ERROR_MESSAGE,
		messages: {
			success: null,
			error: null
		}
	}
}

export function setLanguage (lang) {
	return {
		type: types.SET_LANGUAGE,
		language: {
			currentLang: lang
		}
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/actions.js